import {
  Popper,
  IconButton,
  Typography,
  Paper,
  TextField,
  PopperPlacementType,
} from '@mui/material';
import React from 'react';
import { Add, Close } from '@mui/icons-material';
import { formatMoney } from '../../../../../../../../../../../../../../lib/functions/utils';

const GuaranteeObservationPopper = (props: any) => {
  const { formData, handleChange, handleChangeMoney, onEditing, disabled } =
    props;
  const [openPopper, setOpenPopper] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null,
  );
  const [placement, setPlacement] =
    React.useState<PopperPlacementType>('right');
  const handleClickPopper =
    (newPlacement: PopperPlacementType) =>
    async (event: React.MouseEvent<HTMLButtonElement>) => {
      console.log('click', placement, newPlacement);
      setAnchorEl(event.currentTarget);
      setOpenPopper((prev) => placement !== newPlacement || !prev);
      setPlacement(newPlacement);
    };

  const handleChangeGuaranteeAmount = (value: string) => {
    const newValue = value.split('$').join('').split('.').join('');
    const numberValue = Number(newValue);
    if (numberValue > formData.amount) {
      return alert(
        'El monto en garantía no puede ser mayor al monto del crédito',
      );
    } else {
      setOpenPopper(false);
    }
    handleChange(Number(newValue), 'guaranteeAmount');
  };

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <TextField
          fullWidth
          label="Monto en garantía"
          value={formatMoney(formData.guaranteeAmount)}
          onChange={(e) => handleChangeGuaranteeAmount(e.target.value)}
          margin="dense"
          size="small"
          disabled={disabled}
        />
        <IconButton
          onClick={handleClickPopper(
            // addIconPlacement === 'end' ? 'right' : 'left-end',
            'right',
          )}
        >
          <Add />
          {/* <Typography
              style={{
                position: 'absolute',
                bottom: -5,
                right: 0,
                color: 'white',
                fontSize: 10,
                padding: '2px 6px',
                borderRadius: 50,
                fontWeight: '400',
                margin: '1px 2px',
                backgroundColor: '#297dff',
              }}
            >
              {creditRequest.warranties.length}
            </Typography>
          ) : null} */}
        </IconButton>
      </div>
      <Popper
        sx={{ zIndex: 1300 }}
        open={openPopper}
        anchorEl={anchorEl}
        placement={'bottom'}
        transition={false}
        modifiers={[
          {
            name: 'preventOverflow',
            options: {
              altBoundary: true,
              tether: true,
              rootBoundary: 'document',
              padding: 8,
            },
          },
        ]}
      >
        <Paper
          style={{
            padding: 20,
            minWidth: 300,
            maxHeight: 400,
            overflow: 'scroll',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography variant="body1">
              Observación monto en garantía
            </Typography>
            <IconButton onClick={() => setOpenPopper(false)}>
              <Close />
            </IconButton>
          </div>
          <TextField
            value={formData.guaranteeObservation}
            type="text"
            fullWidth
            disabled={
              !onEditing ||
              !formData.guaranteeAmount ||
              formData.guaranteeAmount <= 0
            }
            multiline
            rows={3}
            placeholder="Observación"
            onChange={(e) =>
              handleChange(e.target.value, 'guaranteeObservation')
            }
          />
        </Paper>
      </Popper>
    </div>
  );
};

export default GuaranteeObservationPopper;
